var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSurfaceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STENI-pattern-generator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "choose-product-menu-open-pre",
    transform: "translate(-741.000000, -337.000000)",
    stroke: "#E13527",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(698.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5507046,42.4492954 L56,38 L60.4492954,42.4492954 L56,46.8985907 L51.5507046,42.4492954 Z M51.5507046,57.5507046 L56,53.1014093 L60.4492954,57.5507046 L56,62 L51.5507046,57.5507046 Z M59.1014093,50 L63.5507046,45.5507046 L68,50 L63.5507046,54.4492954 L59.1014093,50 Z M44,50 L48.4492954,45.5507046 L52.8985907,50 L48.4492954,54.4492954 L44,50 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurfaceActive);
export default __webpack_public_path__ + "static/media/icon-surface-active.5aab8f5f56460a86a7a364e2ddc0b8d9.svg";
export { ForwardRef as ReactComponent };